export const en = {
  nav: {
    home: 'Home',
    about: 'About Us',
    programs: 'Academic Programs',
    admissions: 'Admissions',
    contact: 'Contact',
    more: 'More',
    requestInfo: 'Request Information',
    scheduleVisit: 'Schedule a Visit',
  },
  hero: {
    title: 'Aspire to the highest with humility',
    subtitle: 'Reach your full potential through academic innovation, personalized education, and comprehensive training.',
    ctaInfo: 'Request Information',
    ctaVisit: 'Schedule a Visit',
  },
  home: {
    heroBadge: 'SAN LORENZO SCHOOL OF INNOVATION',
    scrollDown: 'Discover more',
    benefitsBadge: 'What Sets Us Apart',
    programsBadge: 'Comprehensive Education',
    galleryBadge: 'Gallery',
    ctaTitle: 'Ready to join our community?',
    ctaSubtitle: 'Discover why San Lorenzo is the second home for many families.',
  },
  stats: {
    students: 'Students',
    years: 'Years of experience',
    teachers: 'Qualified teachers',
    languages: 'Languages',
  },
  benefits: {
    title: 'Why choose San Lorenzo School?',
    academic: 'Academic Excellence',
    academicDesc: 'High-quality educational programs with outstanding results in national assessments.',
    bilingual: 'Trilingual Education',
    bilingualDesc: 'Immersion in Spanish, French, and English from preschool, preparing students for a globalized world.',
    innovation: 'Technology',
    innovationDesc: 'Classrooms equipped with cutting-edge technology, computer labs, robotics programs, and 3D design.',
    sports: 'Curricular Innovation',
    sportsDesc: 'Comunica+, Life Skills, financial education, research, and fundamentals of administration.',
    arts: 'Arts & Culture',
    artsDesc: 'Music, painting, dance, sculpture, and visual arts programs that foster creativity and expression.',
    values: 'Values Formation',
    valuesDesc: 'Emphasis on ethics, respect, responsibility, honesty, and community service to form whole human beings.',
  },
  programs: {
    title: 'Academic Programs',
    subtitle: 'We offer comprehensive education from preschool to high school, designed to develop the maximum potential of each student.',
    preschool: 'Preschool',
    preschoolDesc: 'A safe and stimulating environment where children develop cognitive, social, and emotional skills through play and exploration.',
    primary: 'Elementary',
    primaryDesc: 'Solid foundation in core areas with active methodologies that develop critical thinking and creativity.',
    secondary: 'High School',
    secondaryDesc: 'Rigorous academic preparation with career guidance, research projects, and leadership development.',
    methodology: 'Methodology',
    methodologyDesc: 'Project-Based Learning, gamification, and STEM methodology.',
    benefits: 'Benefits',
    activities: 'Activities & Services',
    heroBadge: 'Comprehensive Education',
    ages: {
      preschool: '2 - 5 years',
      primary: '6 - 11 years',
      secondary: '12 - 17 years',
    },
    preschoolMethodology: [
      'Project-Based Learning',
      'Gamification',
      'STEM for Preschool',
      'Sensory exploration',
    ],
    preschoolBenefits: [
      'Safe and stimulating environment',
      'Teachers specialized in early childhood education',
      'Small groups for personalized attention',
      'Comprehensive child development',
    ],
    preschoolActivities: [
      'Day Care / After School (no additional cost)',
      'Extracurricular clubs',
      'Slow Coffee: Cafeteria with 3 meal times (additional cost)',
    ],
    primaryMethodology: [
      'Project-Based Learning',
      'Gamification',
      'STEM Methodology',
      'Quarterly Assessment',
    ],
    primaryBenefits: [
      'Solid foundation in core areas',
      'Logical-mathematical thinking development',
      'Trilingual education',
      'Socio-emotional skills',
    ],
    primaryActivities: [
      'Day Care / After School (no additional cost)',
      'Extracurricular clubs',
      'Slow Coffee: Cafeteria with 3 meal times (additional cost)',
    ],
    secondaryMethodology: [
      'Project-Based Learning',
      'Gamification',
      'STEM Methodology',
      'Quarterly Assessment',
    ],
    secondaryBenefits: [
      'Preparation for top universities',
      'Curricular Innovation',
      'Values formation',
      'Community service',
    ],
    secondaryActivities: [
      'Extracurricular clubs',
      'Slow Coffee: Cafeteria with 3 meal times (additional cost)',
    ],
  },
  news: {
    title: 'News & Events',
    subtitle: 'Stay up to date with the latest news, achievements, and activities of our educational community.',
    readMore: 'Read more',
    allNews: 'View all news',
  },
  gallery: {
    title: 'Our Community',
    subtitle: 'Special moments, achievements, and activities that make San Lorenzo School a unique place.',
  },
  about: {
    title: 'About San Lorenzo School',
    heroBadge: 'Get to Know Us',
    history: {
      title: 'Magnanimity',
      desc: 'Maximize the soul, do the right thing even when it costs, to achieve a greater good.',
    },
    historyBadge: 'Our Core Value',
    mission: {
      title: 'Mission',
      desc: 'To educate people capable of thinking, creating, serving, and leading with purpose.'
    },
    vision: {
      title: 'Vision',
      desc: 'For each student to discover and develop their maximum potential on the path toward innovation.',
    },
    values: {
      title: 'Our Values',
      excellence: 'Excellence',
      integrity: 'Integrity',
      respect: 'Respect',
      innovation: 'Innovation',
      responsibility: 'Responsibility',
      solidarity: 'Solidarity',
    },
    philosophy: {
      title: 'Pillars of San Lorenzo',
      desc: ['STEM', 'Design', 'Innovation', 'Entrepreneurship', 'Life Skills'],
    },
    philosophyBadge: 'Pillars of San Lorenzo',
    team: {
      title: 'Leadership and Faculty Team',
      subtitle: 'Highly qualified professionals committed to excellence in education.',
    },
  },
  studentLife: {
    title: 'Student Life',
    subtitle: 'A complete educational experience that goes beyond the classroom. Discover the activities that make San Lorenzo School a special place.',
    sports: {
      title: 'Sports',
      desc: 'Sports programs including soccer, basketball, volleyball, gymnastics, badminton, and more. We have top-tier facilities and certified coaches.',
    },
    arts: {
      title: 'Arts & Culture',
      desc: 'Music, painting, dance, sculpture, visual arts, aerial silks, dance, ballet, and cold porcelain crafts programs that foster creativity.',
    },
    technology: {
      title: 'Technology',
      desc: 'Computer labs, robotics programs, app development, and preparation for the digital age. Programming clubs and science competitions.',
    },
    clubs: {
      title: 'Clubs & Activities',
      desc: 'Clubs: Catechism, Mini Chef, Mini Vets. Activities designed to develop skills and passions in each student.',
    },
    service: {
      title: 'Services',
      desc: 'Day Care from 6:00 a.m. to 6:00 p.m. at no additional cost. Slow Coffee available at an additional cost.',
    },
    events: {
      title: 'Institutional Events',
      desc: 'Sports days, science fairs, concerts, graduations, award ceremonies, and cultural celebrations that unite the entire community.',
    },
  },
  admissions: {
    title: 'Admission Process',
    subtitle: 'We accompany you every step of the way so your family can become part of the San Lorenzo School community.',
    heroBadge: 'Join Us',
    process: {
      title: 'Admission Process',
      badge: 'Step by Step',
      step1: 'Request Information',
      step1Desc: 'Write or call us on WhatsApp to receive detailed information about our programs.',
      step2: 'Guided Visit',
      step2Desc: 'Schedule a personalized visit to see our facilities, methodology, and educational community.',
      step3: 'Interview & Assessment',
      step3Desc: 'We conduct a family interview and an academic assessment of the student to ensure the best fit.',
      step4: 'Enrollment',
      step4Desc: 'Once accepted, we complete the enrollment process with all required documentation.',
    },
    requirements: {
      title: 'Requirements',
      badge: 'Documentation',
      item1: 'Completed admission form',
      item2: 'Copy of student identification',
      item3: 'Previous year report card',
      item4: 'Recommendation letter from previous school',
      item5: 'Interview with parents',
      item6: 'Student academic assessment',
    },
    faq: {
      title: 'Frequently Asked Questions',
      q1: 'What is the tuition cost?',
      a1: 'Costs vary by educational level. Contact us to receive a personalized quote with all tuition and included services information.',
      q2: 'Do you accept students during the school year?',
      a2: 'Yes, we evaluate admissions throughout the school year depending on availability in each grade.',
      q3: 'Do you offer school transportation?',
      a3: 'Yes, we have school transportation service covering different areas of San José and nearby regions.',
      q4: 'Do you have scholarship programs?',
      a4: 'We offer academic and sports scholarship programs. Check requirements and application with our admissions department.',
      q5: 'What is the school schedule?',
      a5: 'Regular schedule is Monday through Thursday from 7:30 a.m. to 2:45 p.m. and Friday from 7:30 a.m. to 2:05 p.m., with extracurricular activities until 4:30 p.m.',
      q6: 'Do students wear uniforms?',
      a6: 'Yes, we have an institutional uniform that promotes identity and equity within the school community.',
    },
    cta: {
      title: 'Ready to take the first step?',
      subtitle: 'Write or call us on WhatsApp to receive detailed information about our programs.',
      button: 'Request Information via WhatsApp',
    },
    form: {
      badge: 'Request Information',
      title: 'Request information about our programs',
      subtitle: 'Fill out the form and we will contact you to provide all the information you need.',
      name: 'Full name',
      email: 'Email address',
      phone: 'Phone',
      subject: 'Program of interest',
      subjectPlaceholder: 'Select a program',
      message: 'Message or inquiry',
      submit: 'Request information',
      sending: 'Sending...',
      success: 'Thank you! Your request has been sent successfully. We will contact you soon.',
      error: 'Error sending. Please try again.',
      preschool: 'Preschool',
      primary: 'Elementary',
      secondary: 'High School',
      generalInfo: 'General Information',
    },
    whatsappMessage: 'Hello, I would like to receive information about the programs at San Lorenzo School',
  },
  contact: {
    title: 'Contact',
    subtitle: 'We are here to answer all your questions. Contact us and we will respond as soon as possible.',
    heroBadge: 'We Are Here',
    infoBadge: 'Information',
    address: 'Address',
    addressValue: 'Main Street, San Pedro, Montes de Oca, San José, Costa Rica',
    phone: 'Phone',
    phoneValue: '+506 8349 5115',
    email: 'Email',
    emailValue: 'admision@sanlorenzocr.com',
    hours: 'Office Hours',
    hoursValue: 'Monday to Friday: 8:00 a.m. - 4:00 p.m.',
    form: {
      title: 'Send us a message',
      name: 'Full name',
      email: 'Email address',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      submit: 'Send message',
      sending: 'Sending...',
      success: 'Thank you! Your message has been sent successfully.',
      error: 'Error sending. Please try again.',
    },
    visitaTab: 'Schedule Visit',
    contactoTab: 'Contact',
    visita: {
      title: 'Schedule a campus visit',
      preferredDate: 'Preferred visit date',
      submit: 'Schedule visit',
      sending: 'Sending...',
      success: 'Thank you! Your visit request has been sent successfully. We will contact you soon.',
      error: 'Error sending. Please try again.',
    },
    followUs: 'Follow us on social media',
  },
  footer: {
    description: 'Aspire to the highest with humility.',
    quickLinks: 'Quick Links',
    programs: 'Programs',
    contact: 'Contact',
    address: 'San Pedro, Montes de Oca, San José, Costa Rica',
    hours: 'Monday - Friday, 8:00 AM - 4:00 PM',
    email: 'admision@sanlorenzocr.com',
    rights: 'All rights reserved.',
    privacy: 'Privacy Policy',
    terms: 'Terms of Use',
  },
  whatsapp: {
    message: 'Hello! I would like to receive information about San Lorenzo School',
    helpBubble: 'Need help?',
  },
  common: {
    learnMore: 'Learn more',
    viewAll: 'View all',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    galleryImage: 'Gallery image',
  },
};